@if (isVisible()) {
    <div class="fixed inset-0 bg-gray-100 bg-opacity-60 flex justify-center items-center z-50">
      <div class="bg-white rounded-lg shadow-lg w-1/3 p-4">
        <div>
          <ng-content></ng-content>
        </div>
      </div>
    </div>
}
  